import { useState } from "react";
import { VeryBtnFill } from "../../common/v2/VeryBtnFill";
import { classVeryBtnFill } from "../../common/v2/VeryBtnFill/classVeryBtnFill";
import { VeryInput } from "../../common/v2/VeryInput";
import CustomDatePicker from "../../common/custom-datePicker";
import { momentES } from "../../../utils/handler_dates";
import Styles from "./styles";
import { useCancellationsContext } from "../../../context";

export const ModalCompensatePassenger = () => {
  const cancellations = useCancellationsContext();
  const [amount, setAmount]   = useState("");
  const [expDate, setExpDate] = useState(momentES().add(6, "months"));
  const [errors, setErrors]   = useState({ amount: "" });

  const onConfirm = () => {
    const parsed = parseFloat(amount);
    if (!parsed || parsed <= 0) {
      setErrors({ amount: "Ingresa un monto válido mayor a 0" });
      return;
    }
    setErrors({ amount: "" });
    const expDateStr = expDate ? expDate.format("YYYY-MM-DD") : "";
    cancellations.execCompensatePassenger({
      couponAmount:  parsed,
      couponExpDate: expDateStr,
    });
  };

  const onClose = () => {
    setAmount("");
    setExpDate(momentES().add(6, "months"));
    setErrors({ amount: "" });
    cancellations.closeModalCompensatePassenger();
  };

  return (
    <Styles.Modal
      CSS={["modalCompensatePassenger"]}
      title="Compensar pasajero con cupón"
      isVisible={cancellations.modalCompensate.show}
      onClickClose={onClose}
      buttons={[
        <VeryBtnFill
          CSS={["btnModal"]}
          label="Asignar cupón a cartera"
          isLoading={cancellations.actionLoading}
          onClick={onConfirm}
          colorTheme={classVeryBtnFill.COLOR_THEME.BLACK_S1}
        />,
      ]}
    >
      <VeryInput
        title="Monto del cupón (MXN)"
        isEditable
        placeHolder="$ 0"
        text={amount}
        textError={errors.amount}
        onChangeText={(v) => { setAmount(v); setErrors({ amount: "" }); }}
      />
      <CustomDatePicker
        className="div-expirationDate"
        classNamePicker="pickerExpirationDate"
        title="Fecha de expiración"
        error=""
        minDate={momentES().add(1, "days")}
        maxDate={null}
        selectedDate={expDate}
        onChange={(d) => setExpDate(d)}
      />
    </Styles.Modal>
  );
};
